import { useEffect, useRef } from 'react';
import { SITE_ORIGIN } from '../data/seo';

/**
 * Google Analytics 4 measurement ID — looks like "G-XXXXXXXXXX". Paste yours
 * here (Admin → Data Streams → your web stream) and tracking switches on.
 * Left empty, nothing loads and no requests are made.
 */
export const GA_MEASUREMENT_ID = 'G-G3QMSZ23EL';
declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * The site is a single page app, so gtag's automatic pageview only ever fires
 * once. Auto-send is disabled and a page_view is sent per route instead, which
 * is what makes /how and /contact show up as distinct pages in GA.
 */
export function Analytics({
  pathname
}: {
  pathname: string;
}) {
  const loaded = useRef(false);
  useEffect(() => {
    if (!GA_MEASUREMENT_ID || loaded.current) return;
    loaded.current = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer!.push(args);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: false
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }, []);
  useEffect(() => {
    if (!GA_MEASUREMENT_ID || !window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: pathname,
      page_location: `${SITE_ORIGIN}${pathname}`,
      page_title: document.title
    });
  }, [pathname]);
  return null;
}